import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M80.308-867.075L867.075-80.308 824.307-37.54 721.846-140.001H212.309q-30.308 0-51.308-21t-21-51.308v-509.537L37.54-824.307l42.768-42.768zm284.308 405.843L200-296.655v84.346q0 4.616 3.846 8.463 3.847 3.846 8.463 3.846h449.538L543.231-318.616l-17 18.615-161.615-161.231zM200-661.847v279.694L339.847-522 200-661.847zm41.385-158.152h506.306q30.308 0 51.308 21t21 51.308v506.306L760-301.384v-261.694L636.537-424.846l-42.768-42.768L760-653.076v-94.615q0-4.616-3.846-8.463-3.847-3.846-8.463-3.846H301.384l-59.999-59.999zm352.384 352.385zm-152.615 46.921zM339.847-522zm24.769 60.768zm164.076-71.46z"
      ></path>
    </svg>
  );
}

export default Icon;
